import { handleVersionMismatch } from 'actions/versionSync';
import { VersionMismatch } from 'services/BaseService';
import StoryletService from 'services/StoryletService';

import { processMessages } from 'actions/app';
import { fetchOutfit, fetchMyself } from 'actions/myself';

import chooseBranchFailure from './chooseBranchFailure';
import chooseBranchRequest from './chooseBranchRequest';
import chooseBranchSuccess from './chooseBranchSuccess';

/** ----------------------------------------------------------------------------
 * CHOOSE A BRANCH
 -----------------------------------------------------------------------------*/
export default chooseBranch(new StoryletService());

export function chooseBranch(service) {
  return branchData => async (dispatch) => {
    // We're requesting
    dispatch(chooseBranchRequest());
    try {
      // Check whether the branch being has cost-type requirements. We will not
      // receive cost-related quality updates in the API response, so we need to
      // prepare to trigger fetches of the character's myself+outfit qualities
      const { qualityRequirements = [] } = branchData;
      const hasCosts = qualityRequirements.some(qreq => qreq.isCost);

      // Make the request
      const { data } = await service.chooseBranch(branchData);

      // OK, success!
      dispatch(chooseBranchSuccess(data));

      // If this branch incurred a cost, then fetch outfit + possessions too
      if (hasCosts) {
        dispatch(fetchMyself());
        dispatch(fetchOutfit());
      }

      const { messages } = data;
      dispatch(processMessages(messages));

    } catch (error) {
      if (error instanceof VersionMismatch) {
        dispatch(handleVersionMismatch(error));
      }
      dispatch(chooseBranchFailure(error));
    }
  };
}